module.exports = __webpack_public_path__ + "img/horizontal_4_6_3.df0580c2.png";